import React from 'react';

export const SidebarLayout = ({ slots, spacingMultiplier = 1.0, sidebarPosition = 'left' }) => {
  const { header, main, sidebar, footer } = slots;
  
  // Define grid layout columns depending on sidebar position
  const gridTemplateColumns = sidebarPosition === 'right' 
    ? '1fr var(--layout-sidebar-width, 240px)' 
    : 'var(--layout-sidebar-width, 240px) 1fr';
  
  return (
    <div 
      className="resume-layout-sidebar-container" 
      style={{
        display: 'grid',
        gridTemplateRows: 'auto 1fr auto',
        minHeight: '100%',
        boxSizing: 'border-box',
        gap: `calc(var(--spacing-element-gap, 16px) * ${spacingMultiplier})`
      }}
    >
      {header && (
        <header className="resume-header-slot" style={{ gridColumn: '1 / -1' }}>
          {header}
        </header>
      )}

      <div 
        className="resume-columns-body" 
        style={{
          display: 'grid',
          gridTemplateColumns: gridTemplateColumns,
          gap: `calc(var(--layout-column-gap, 20px) * ${spacingMultiplier})`
        }}
      >
        {/* Render sidebar first if left, main first if right to maintain DOM layout flow for screen readers */}
        {sidebarPosition === 'left' ? (
          <>
            <aside 
              className="resume-sidebar-slot"
              style={{
                background: 'var(--layout-sidebar-bg, transparent)',
                color: 'var(--layout-sidebar-text, inherit)',
                padding: 'var(--layout-sidebar-padding, 0)',
                borderRight: 'var(--layout-sidebar-border, none)',
                boxSizing: 'border-box',
                '--color-primary': 'var(--layout-sidebar-text, var(--color-primary))',
                '--color-secondary': 'var(--layout-sidebar-text, var(--color-secondary))',
                '--color-text-main': 'var(--layout-sidebar-text, var(--color-text-main))',
                '--color-text-light': 'var(--layout-sidebar-text, var(--color-text-light))',
                '--color-border': 'color-mix(in srgb, var(--layout-sidebar-text, var(--color-border)) 25%, transparent)',
              }}
            >
              {sidebar}
            </aside>
            <main 
              className="resume-main-slot"
              style={{
                padding: 'var(--layout-main-padding, 0)',
                boxSizing: 'border-box'
              }}
            >
              {main}
            </main>
          </>
        ) : (
          <>
            <main 
              className="resume-main-slot"
              style={{
                padding: 'var(--layout-main-padding, 0)',
                boxSizing: 'border-box'
              }}
            >
              {main}
            </main>
            <aside 
              className="resume-sidebar-slot"
              style={{
                background: 'var(--layout-sidebar-bg, transparent)',
                color: 'var(--layout-sidebar-text, inherit)',
                padding: 'var(--layout-sidebar-padding, 0)',
                borderLeft: 'var(--layout-sidebar-border, none)',
                boxSizing: 'border-box',
                '--color-primary': 'var(--layout-sidebar-text, var(--color-primary))',
                '--color-secondary': 'var(--layout-sidebar-text, var(--color-secondary))',
                '--color-text-main': 'var(--layout-sidebar-text, var(--color-text-main))',
                '--color-text-light': 'var(--layout-sidebar-text, var(--color-text-light))',
                '--color-border': 'color-mix(in srgb, var(--layout-sidebar-text, var(--color-border)) 25%, transparent)',
              }}
            >
              {sidebar}
            </aside>
          </>
        )}
      </div>

      {footer && (
        <footer className="resume-footer-slot" style={{ gridColumn: '1 / -1' }}>
          {footer}
        </footer>
      )}
    </div>
  );
};
